<button class="dialog-button"
        [class.dialog-button--transparent]="transparent()"
        (click)="onClick.emit()">
    <div class="label" [class.danger-text]="danger()">
        {{ subtitle() }}
    </div>
    <div class="flex">
        <div class="content">
            <ng-content></ng-content>
        </div>
        <div class="icon-wrapper">
            <img class="rotate" ngSrc="/assets/img/icons/black-arrow.svg"
                 priority="true"
                 width="24" height="24"
                 alt=""/>
        </div>
    </div>
</button>
